import React, { PropTypes } from 'react';
import ObjectRelObjectsObject from '../../../Object/RelObjects/Object'
import localize from '../../../../localize'
import { getCurrentLanguage } from '../../../../localData';

const PersonDetailObjectList = ({ person }) => {
    const objects = person.PerObjects.edges && person.PerObjects.edges.length ? (
        person.PerObjects.edges.map(edge => <ObjectRelObjectsObject key={ edge.node.ObjId } object={ edge.node } />)
    ) : [];

    const l = (key) => {
        const str = `${getCurrentLanguage()}.components.PersonDetail.${key}`;
        return localize(str);
    };

    return (
        objects.length ? (
            <section>
                <div className="detail-section-header">
                    <h2 className="content-box">
                        { l('PerObjectsRel')}
                    </h2>
                </div>
                <ul className="object-list">
                    { objects }
                </ul>
            </section>
        ) : <div></div>
    );
};

PersonDetailObjectList.propTypes = {
    person: PropTypes.object.isRequired,
};

export default PersonDetailObjectList;


// WEBPACK FOOTER //
// ./app/components/Person/Detail/ObjectList/ObjectList.jsx